import { firebaseApp } from "./firebase";
import "firebase/storage";

export const firestorage = firebaseApp.storage();
